import { liquidSettleEvent } from '@/play/liquid/changes'
import { liquidKind } from '@/play/liquid/kind'

/** Slime is glossy blob voxels: every blob in a Moon slime world is slime. */
export const SLIME_LIQUID = liquidKind('blob')

/**
 * A pour's sim delta, one event per commit; a whole press is one undo step. The coalescer
 * accumulates in place, so committing a long press costs O(cells), not O(events x cells).
 */
export const SLIME_SETTLE = liquidSettleEvent('experience.moon-slime.settle', SLIME_LIQUID)

/** Reducer handlers for Moon slime (`experience.moon-slime.*`). */
export const eventHandlers = SLIME_SETTLE.handlers
